import { render, staticRenderFns } from "./PrimitiveElement.vue.js?vue&type=template&id=7f9a7ace&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PrimitiveElement.vue?vue&type=template&id=7f9a7ace&scoped=true"
import script from "./PrimitiveElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PrimitiveElement.vue?vue&type=script&lang=js"
export * from "./PrimitiveElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PrimitiveElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a7ace",
  null
  
)

export default component.exports